const carrierServices = [
	'FedEx Ground',
	'FedEx Express',
	'UPS Ground',
	'UPS Express',
	'USPS Priority Mail Express',
	'USPS First Class Mail',
];

export { carrierServices };



// WEBPACK FOOTER //
// ./src/common/constants/carrierServiceConstants.js